// extracted by mini-css-extract-plugin
export var container = "Login-module--container--I-bOP";
export var divider = "Login-module--divider--M+JDe";
export var forgotPassword = "Login-module--forgot-password--DIGZk";
export var header = "Login-module--header--Q3pxQ";
export var intro = "Login-module--intro--S+0pr";
export var login = "Login-module--login--WeolH";
export var loginForm = "Login-module--loginForm--wfFH-";